import { DataTableValidators } from 'src/app/shared/data-table/validators';
import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { EcmToolChangeService } from '../../ecm-tool-change.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CgpAlertDialogService, cgpAlertTypes } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { EcmService } from '../../../ecm.service';
import { ToastrService } from 'ngx-toastr';

@Component({
   // tslint:disable-next-line: component-selector
   selector: 'etc-add-authority',
   templateUrl: './etc-add-authority.component.html',
   styleUrls: ['./etc-add-authority.component.scss']
})
export class EtcAddAuthorityComponent implements OnInit {
   authTypes: any[] = [];
   loading = false;
   numericRegex = /^[0-9]*$/;

   alphabeticRegex = /^[a-zA-Z]*$/;
   isNew: any;
   selectedTool: any;
   selected: any;

   addAuthorityForm = new UntypedFormGroup({
      authNumber: new UntypedFormControl('', [Validators.maxLength(20)]),
      authNumberN: new UntypedFormControl('', [Validators.required, Validators.maxLength(20)]),
      authTypeName: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
      authDescription: new UntypedFormControl('', [Validators.maxLength(500)]),
   }, {
      updateOn: 'blur',
      validators: (group: UntypedFormGroup) => {
         const authNumber = group.get('authNumber');
         const authTypeName = group.get('authTypeName').value;
         if (authNumber.value) {
            if (authTypeName === 'AVO') {
               authNumber.setErrors({ avoType: true });
            } else {
               authNumber.setErrors(null);
            }
         } else if (authTypeName !== 'AVO') {
            authNumber.setErrors({ required: true });
         } else {
            authNumber.setErrors(null);
         }

         return {};
      }
   });

   constructor(
      private readonly dialogRef: MatDialogRef<EtcAddAuthorityComponent>,
      private readonly fb: UntypedFormBuilder,
      private readonly toastr: ToastrService,
      private readonly ecmService: EcmService,
      private readonly ecmToolChangeService: EcmToolChangeService,
      private readonly cgpAlertDialogService: CgpAlertDialogService,
      @Inject(MAT_DIALOG_DATA) public readonly data: any
   ) { }



   ngOnInit() {
      this.loading = true;
      this.selectedTool = this.data.selectedTool;
      this.selected = this.data.selected;
      this.isNew = this.data.isNew;
      if (!this.isNew) {
         this.addAuthorityForm = this.fb.group({
            authNumber: [this.selected.authNumber, [Validators.maxLength(20)]],
            authNumberN: [this.selected.authNumberN, [Validators.required, Validators.maxLength(20)]],
            authTypeName: [this.selected.authTypeName, [Validators.required, Validators.maxLength(10)]],
            authDescription: [this.selected.authDescription, [Validators.maxLength(500)]]
         });
      }
      this.ecmService.getAuthTypeCriteria()
         .subscribe({
            next: (res) => {
               if (res) {
                  this.authTypes = res;
               }
            },
            complete: () => this.loading = false
         });
   }

   onCancelClick() {
      this.dialogRef.close();
   }

   onAddClick() {
      let body = {};

      if (this.isNew) {
         body = {
            ...this.addAuthorityForm.value,
            partChangeID: this.selectedTool.partChangeId,
            toolChangeID: this.selectedTool.toolChangeId
         };
      }

      if (!this.isNew) {
         body = {
            ...this.addAuthorityForm.value,
            partChangeID: this.selectedTool.partChangeId,
            toolChangeID: this.selectedTool.toolChangeId,
            authID: this.selected.authID,
            fmtaddedBy: this.selected.fmtaddedBy,
            fmtaddedDate: this.selected.fmtaddedDate,
            fmtlastUpdatedBy: this.selected.fmtlastUpdatedBy,
            fmtlastUpdatedDate: this.selected.fmtlastUpdatedDate
         };
      }



      this.loading = true;
      (this.isNew ?
         this.ecmToolChangeService.addAuthority.bind(this.ecmToolChangeService) :
         this.ecmToolChangeService.updateAuthority.bind(this.ecmToolChangeService)
      )(body)
         .subscribe({
            next: (res) => {
               this.cgpAlertDialogService.showAlertDialog({
                  title: this.isNew ? 'Add Authority' : 'Update Authority',
                  message: this.isNew ? 'Authority was added successfully!' : 'Authority was updated successfully!',
                  alert: cgpAlertTypes.success,
                  closeLabel: 'Close'
               }).afterClosed().subscribe(() => this.dialogRef.close({
                  reload: true,
                  authId: !this.isNew ? this.selected.authID : null
               }));
            },
            error: (err) => {
               this.loading = false;
               this.cgpAlertDialogService.showAlertDialog({
                  title: this.isNew ? 'Add Authority Failed' : 'Update Authority Failed',
                  message: this.isNew ? 'Authority could not be added. Please try again!' : 'Authority could not be updated. Please try again!',
                  alert: cgpAlertTypes.danger,
                  closeLabel: 'Close'
               });
            },
            complete: () => this.loading = false
         });

   }

   authAlphaFieldCheck(event: any) {
      const authType = this.addAuthorityForm.get('authTypeName').value;
      const authAlpha = this.addAuthorityForm.get('authNumber').value;

      if (!this.isNew) {
         if ((authAlpha === '' || authAlpha === null) && authType === 'EWO') {
            const ref = this.cgpAlertDialogService.showAlertDialog({
               message: 'Removing the Authority #(alpha) will change the Authority Type to AVO'
            });
            ref.afterClosed().subscribe(() => {
               this.addAuthorityForm.get('authTypeName').reset('AVO');
            });
         }
         if ((authAlpha !== '' || authAlpha === null) && authType === 'AVO') {
            const ref = this.cgpAlertDialogService.showAlertDialog({
               message: 'Adding the Authority #(alpha) will change the Authority Type to EWO'
            });
            ref.afterClosed().subscribe(() => {
               this.addAuthorityForm.get('authTypeName').reset('EWO');
            });
         }
      }
   }

   authTypeFieldCheck(event: any) {
      const authType = this.addAuthorityForm.get('authTypeName').value;
      const authAlpha = this.addAuthorityForm.get('authNumber').value;

      if (!this.isNew) {
         if ((authAlpha === '' || authAlpha === null) && authType === 'EWO') {
            const ref = this.cgpAlertDialogService.showAlertDialog({
               width: '480px',
               message: 'You cannot select the Authority Type EWO unless you have entered the Authority #(alpha) and Authortity #(numeric). Please try again.'
            });
            ref.afterClosed().subscribe(() => {
               this.addAuthorityForm.get('authTypeName').reset('AVO');
            });
         }
         if ((authAlpha !== '' || authAlpha === null) && authType === 'AVO') {
            const ref = this.cgpAlertDialogService.showAlertDialog({
               width: '480px',
               message: 'You cannot select the Authority Type AVO unless you have entered the  Authortity #(numeric) and Authority #(alpha) is blank. Please try again.'
            });
            ref.afterClosed().subscribe(() => {
               this.addAuthorityForm.get('authTypeName').reset('EWO');
            });
         }
      }
   }


} 
